/**
 * Metadata for the fixed public pages that existed before this change.
 *
 * These pages have hand-written content rather than marketplace data, so their
 * copy lives here instead of being templated. They still flow through the same
 * `buildMetadata` engine, which is what gives them a canonical URL, the
 * environment index gate, and consistent Open Graph / Twitter tags.
 *
 * CommonJS on purpose — shared by the CRA bundle and the Node build scripts.
 */

const { buildMetadata } = require('./metadata');

/** @type {Record<string, { title: string, description: string, h1?: string }>} */
const STATIC_PAGE_COPY = {
  '/': {
    title: 'Book Beauty & Wellness Pros Near You | LookBel',
    description:
      'LookBel connects you with independent beauty and wellness professionals across the United States. Browse real profiles, compare services and book online.',
  },
  '/about': {
    title: 'About LookBel | Beauty & Wellness Marketplace',
    description:
      'LookBel is a US marketplace for independent beauty and wellness professionals. Learn how we help clients book and help providers run their business.',
  },
  '/services': {
    title: 'Beauty & Wellness Services on LookBel',
    description:
      'Hair, braiding, barbering, nails, makeup, skincare, lashes, brows, waxing, massage and wellness services from independent professionals on LookBel.',
  },
  '/contact': {
    title: 'Contact LookBel Support',
    description:
      'Get in touch with the LookBel team about your account, a booking, or listing your services as a beauty or wellness professional.',
  },
  '/privacy': {
    title: 'Privacy Policy | LookBel',
    description:
      'How LookBel collects, uses, stores and protects personal information for clients and professionals using the marketplace.',
  },
  '/delete-account': {
    title: 'Delete Your LookBel Account',
    description:
      'How to request deletion of your LookBel account, including without signing in, what is deleted, and what is kept.',
  },
  '/terms': {
    title: 'Terms of Service | LookBel',
    description:
      'The terms that govern use of the LookBel marketplace by clients and independent beauty and wellness professionals.',
  },
  '/provider-agreement': {
    title: 'Service Provider Agreement | LookBel',
    description:
      'The agreement between LookBel and independent professionals who list and deliver services through the marketplace.',
  },
  '/cancellation-policy': {
    title: 'Cancellation Policy | LookBel',
    description:
      'How cancellations, reschedules and no-shows are handled for appointments booked through LookBel.',
  },
  '/community-standards': {
    title: 'Community Standards | LookBel',
    description:
      'The standards of conduct LookBel expects from clients and professionals across the marketplace.',
  },
  '/affiliate-terms': {
    title: 'Affiliate Program Terms | LookBel',
    description: 'The terms that govern participation in the LookBel affiliate program.',
  },
};

/**
 * @param {string} path
 * @param {{ environment?: string, siteUrl?: string }} [ctx]
 * @returns {Object | null} PageMetadata, or null for an unknown path
 */
function staticPageMetadata(path, ctx) {
  const c = ctx || {};
  const copy = STATIC_PAGE_COPY[path];
  if (!copy) return null;
  return buildMetadata({
    title: copy.title,
    description: copy.description,
    path,
    h1: copy.h1,
    indexable: true,
    environment: c.environment,
    siteUrl: c.siteUrl,
  });
}

module.exports = {
  STATIC_PAGE_COPY,
  staticPageMetadata,
};
